"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.CollapseButton = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = require("@emotion/react");
var _Button = _interopRequireDefault(require("../Button"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const CollapseButton = exports.CollapseButton = /*#__PURE__*/(0, _base.default)(_Button.default, process.env.NODE_ENV === "production" ? {
  target: "ehtrwig0"
} : {
  target: "ehtrwig0",
  label: "CollapseButton"
})(process.env.NODE_ENV === "production" ? {
  name: "1dg5z9o",
  styles: "position:relative;display:block;width:100%;font-weight:unset;text-align:unset"
} : {
  name: "1dg5z9o",
  styles: "position:relative;display:block;width:100%;font-weight:unset;text-align:unset",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const styles = exports.styles = {
  default: theme => /*#__PURE__*/(0, _react.css)(".item{padding:2em 0;border-top:1px solid ", theme.border, ";.header{display:flex;justify-content:space-between;align-items:center;&>svg{min-width:14px;}}.content{padding-top:2em;}}.item:last-of-type{border-bottom:1px solid ", theme.border, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:default;"))
};